export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-Docker-f3ca0eb98049476fdb6f39840a3354f4.jpg";